// add swiper
import Swiper from 'swiper';
import {
    Keyboard, Pagination, Virtual, Navigation, Autoplay, Manipulation, A11y, Mousewheel, EffectFade
} from 'swiper/modules';
import { i18n } from '@moxiltd/moxijs/src/i18n.js';
import { SwiperOptions } from 'swiper/types';
import { BaseComponent } from './baseComponent';

export class Slider extends BaseComponent {
    private slider: Swiper;

    constructor(container: HTMLElement, options: Record<string, any> & SwiperOptions) {
        super(container, options)
        this.onLoad();
    }

    public onLoad() {
        super.onLoad();
        this.slider = new Swiper(this.container, this.options);
    }

    public getDefaultOptions(options = {}) {
        const defaultOptions: SwiperOptions = {
            modules: [Pagination, Keyboard, Virtual, Navigation, Autoplay, Manipulation, A11y, Mousewheel, EffectFade],
            loop: true,
            keyboard: {
                enabled: true,
            },
            navigation: {
                nextEl: this.container.querySelector('.my-swiper-button-next') as HTMLElement,
                prevEl: this.container.querySelector('.my-swiper-button-prev') as HTMLElement,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets',
            },
            a11y: {
                firstSlideMessage: i18n.t('sr.first_slide'),
                lastSlideMessage: i18n.t('sr.last_slide'),
                prevSlideMessage: i18n.t('sr.prev_slide'),
                nextSlideMessage: i18n.t('sr.next_slide'),
                slideRole: 'alert',
            },
            on: {
                // prevent focus outside of active panel
                /*slideChange: (slider: Swiper): void => {
                    this.slideChange(slider);
                },*/
                // set bullet labels
                /*init: (slider: Swiper): void => {
                    if (slider.pagination.el === null) return;

                    const bullets = this.container.querySelectorAll('.swiper-pagination-bullet')
                    slider.slides.forEach((slide, i): void => {
                        if (typeof slide.dataset.title === 'undefined') return;

                        const label = i18n.t('sr.show_panel_title', slide.dataset.title)
                        bullets[i].setAttribute('aira-label', label);
                    });
                },*/
            },
        };

        return {
            ...super.getDefaultOptions(),
            ...defaultOptions,
            ...options,
        };
    }

    private slideChange(slider: Swiper) {
        const activeSlide = slider.slides[slider.activeIndex];
        console.log(this.options.slidePerView);
        if (typeof this.options.slidesPerView === 'undefined' || this.options.slidesPerView === 1) {
            slider.slides.forEach(slide => {
                slide.inert = true;
            });
            activeSlide.inert = false;
            activeSlide.focus();
        }
    }

    public open(id: string) {
        this.options.initialSlide = id;
    }
}
